<template>
   <b-container>
       <b-row>
           <b-col md="4" class="mt-3">
               <b-select
                v-model="selectedReport"
                :options="options"
                size="sm"
                @change.native="getReportData"
               ></b-select>
           </b-col>
           <b-col class="mt-3">
               <b-button @click="exportToExcel">Export to Excel</b-button>
           </b-col>
       </b-row>
       <b-row>
       </b-row>
       <b-row>
           <b-col></b-col>
           <b-col md="8" class="mt-3 text-left" >
                <b-table striped hover small :items="tableData" :fields="fields" table-variant="primary" >
                </b-table>
           </b-col>
           <b-col></b-col>
       </b-row>
   </b-container>
</template>

<script>
import apis from "@/apis";
import * as _ from "lodash";
import Spinner from "vue-simple-spinner";
import XLSX from "xlsx";

export default {
  data() {
    return {
      selectedReport: 0,
      options: [
        { value: 0, text: "Select Report to View" },
        { value: 1, text: "District wise Report" },
        { value: 2, text: "Division wise Report" },
        { value: 3, text: "Gender wise Report" },
        { value: 4, text: "Caste wise Report" },
        { value: 5, text: "Age wise Report" },
        { value: 6, text: "Loan Amount wise Report" },
        { value: 7, text: "Year wise Report" }
      ],
      districtReportData: [],
      divisionReportData: [],
      genderReportData: [],
      casteReportData: [],
      ageReportData: [],
      amountReportData: [],
      yearReportData: [],
      tableData: [],
      fields: [
        { key: "Age", sortable: true },
        { key: "District", sortable: true },
        { key: "Division", sortable: true },
        { key: "Gender", sortable: true },
        { key: "Caste", sortable: true },
        { key: "LoanAmount", sortable: true },
        { key: "IL_Applications", sortable: true },
        { key: "GL_Applications", sortable: true },
        { key: "TotalApplications", sortable: true }
      ],
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      ws_name: "District"
    };
  },
  methods: {
    exportToExcel() {
      let filename = this.ws_name + ".xlsx";
      var wb = XLSX.utils.book_new();
      var ws_data = [[this.ws_name + " wise Summary"]];
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 3 } }];
      ws["!merges"] = merge;
      //console.log(ws);
      //   ws["A1"] = {};
      //   ws["A1"].t = "s";
      //   ws['A1'].v = this.ws_name + " wise Summary"
      XLSX.utils.sheet_add_json(ws, this.tableData, {
        skipHeader: false,
        origin: "A3"
      });
      XLSX.utils.book_append_sheet(wb, ws, this.ws_name);
      XLSX.writeFile(wb, filename);
    },
    getReportData(evt) {
      let id = evt.target.value;
      switch (id) {
        case "1":
          this.tableData = this.districtReportData;
          this.fields = [
            { key: "District", sortable: true },
            { key: "IL_Applications", sortable: true },
            { key: "GL_Applications", sortable: true },
            { key: "TotalApplications", sortable: true }
          ];
          this.ws_name = "District";
          break;
        case "2":
          this.tableData = this.divisionReportData;
          this.fields = [
            { key: "Division", sortable: true },
            { key: "IL_Applications", sortable: true },
            { key: "GL_Applications", sortable: true },
            { key: "TotalApplications", sortable: true }
          ];
          this.ws_name = "Division";
          break;
        case "3":
          this.tableData = this.genderReportData;
          this.fields = [
            { key: "Gender", sortable: true },
            { key: "IL_Applications", sortable: true },
            { key: "GL_Applications", sortable: true },
            { key: "TotalApplications", sortable: true }
          ];
          this.ws_name = "Gender";
          break;
        case "4":
          this.tableData = this.casteReportData;
          this.fields = [
            { key: "Caste", sortable: true },
            { key: "IL_Applications", sortable: true },
            { key: "GL_Applications", sortable: true },
            { key: "TotalApplications", sortable: true }
          ];
          this.ws_name = "Caste";
          break;
        case "5":
          this.tableData = this.ageReportData;
          this.fields = [
            { key: "Age", sortable: true },
            { key: "IL_Applications", sortable: true },
            { key: "GL_Applications", sortable: true },
            { key: "TotalApplications", sortable: true }
          ];
          this.ws_name = "Age";
          break;
        case "6":
          this.tableData = this.amountReportData;
          this.fields = [
            { key: "LoanAmount", sortable: true },
            { key: "IL_Applications", sortable: true },
            { key: "GL_Applications", sortable: true },
            { key: "TotalApplications", sortable: true }
          ];
          this.ws_name = "Loan Amount";
          break;
        case "7":
          this.tableData = this.yearReportData;
          this.fields = [
            { key: "FinancialYear", sortable: true },
            { key: "IL_Applications", sortable: true },
            { key: "GL_Applications", sortable: true },
            { key: "TotalApplications", sortable: true }
          ];
          this.ws_name = "Year";
          break;
      }
    }
  },
  mounted() {
    let districtId = this.$store.getters.getUserDistrict;
    let promise = apis.ReadSummaryReports(districtId);

    promise
      .then(response => {
        if (response.status == 200) {
          this.districtReportData = response.body[0].map(x => {
            return {
              District: x.DistrictName,
              IL_Applications: x.TotalIndividual,
              GL_Applications: x.TotalGroup,
              TotalApplications: x.TotalApplications
            };
          });
          this.divisionReportData = response.body[1].map(x => {
            return {
              Division: x.Division,
              IL_Applications: x.TotalIndividual,
              GL_Applications: x.TotalGroup,
              TotalApplications: x.TotalApplications
            };
          });
          this.casteReportData = response.body[2].map(x => {
            return {
              Caste: x.Caste,
              IL_Applications: x.TotalIndividual,
              GL_Applications: x.TotalGroup,
              TotalApplications: x.TotalApplications
            };
          });
          this.genderReportData = response.body[3].map(x => {
            return {
              Gender: x.Gender,
              IL_Applications: x.TotalIndividual,
              GL_Applications: x.TotalGroup,
              TotalApplications: x.TotalApplications
            };
          });
          this.ageReportData = response.body[4].map(x => {
            return {
              Age: x.Age,
              IL_Applications: x.TotalIndividual,
              GL_Applications: x.TotalGroup,
              TotalApplications: x.TotalApplications
            };
          });
          this.amountReportData = response.body[5].map(x => {
            return {
              LoanAmount: x.LoanAmount,
              IL_Applications: x.TotalIndividual,
              GL_Applications: x.TotalGroup,
              TotalApplications: x.TotalApplications
            };
          });
          this.yearReportData = response.body[6].map(x => {
            return {
              FinancialYear: x.FinancialYear,
              IL_Applications: x.TotalIndividual,
              GL_Applications: x.TotalGroup,
              TotalApplications: x.TotalApplications
            };
          });
        } else {
          this.alertText = response.body;
          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
        this.isLoading = false;
      })
      .catch(err => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
        this.isLoading = false;
      });
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/misReport.vue